import { useState, useEffect, createContext, useContext } from "react";
import API from "@/lib/api";

// Hook + context to share the provider roster + assignment filter across tabs.
const ProviderFilterContext = createContext(null);

export function ProviderFilterProvider({ children, currentUserId }) {
  const [patients, setPatients] = useState([]);
  const [providers, setProviders] = useState([]);
  const [filter, setFilter] = useState("all"); // "all" | "me" | provider_id
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await API.get("/provider/patients");
      setPatients(data.patients || []);
      setProviders(data.providers || []);
    } catch {
      // keep prior state
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const assign = async (patientId, providerId) => {
    await API.put(`/provider/patients/${patientId}/assign`, { provider_id: providerId || null });
    await refresh();
  };

  // Compute the set of emails visible for the active filter.
  let visibleEmails = null; // null = show everything
  if (filter === "me") {
    visibleEmails = new Set(patients.filter(p => p.assigned_provider_id === currentUserId).map(p => p.email));
  } else if (filter !== "all") {
    visibleEmails = new Set(patients.filter(p => p.assigned_provider_id === filter).map(p => p.email));
  }

  const isEmailVisible = (email) => visibleEmails === null || visibleEmails.has((email || "").toLowerCase());

  return (
    <ProviderFilterContext.Provider value={{
      patients, providers, filter, setFilter, loading,
      currentUserId, isEmailVisible, assign, refresh,
    }}>
      {children}
    </ProviderFilterContext.Provider>
  );
}

export function useProviderFilter() {
  return useContext(ProviderFilterContext);
}
